import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Mail, Copy } from "lucide-react";
import { ViewOnlyBanner } from "./ViewOnlyBanner";
import { toast } from "sonner";

export const SubscribersTab = ({
  darkMode, subscribers, subscriberCount, adminSearch, viewOnly
}) => {
  const cardBg = darkMode ? "bg-gray-800/80 border border-gray-700/50" : "";

  const handleExportCSV = () => {
    const csv = "Email,Subscribed At\n" + subscribers.map(s => `${s.email},${s.subscribed_at}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "newsletter_subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
    toast.success("CSV downloaded");
  };

  return (
    <>
    {viewOnly && <ViewOnlyBanner darkMode={darkMode} />}
    <Card className={`border-0 shadow-soft rounded-3xl ${cardBg}`}>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className={`flex items-center gap-2 ${darkMode ? "text-gray-100" : ""}`}><Mail className="w-5 h-5" /> Newsletter Subscribers ({subscriberCount})</CardTitle>
        {!viewOnly && (
        <Button
          variant="outline"
          size="sm"
          className={`rounded-xl ${darkMode ? "bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600" : ""}`}
          onClick={handleExportCSV}
          disabled={subscribers.length === 0}
          data-testid="export-subscribers"
        >
          <Copy className="w-3.5 h-3.5 mr-1" /> Export CSV
        </Button>
        )}
      </CardHeader>
      <CardContent>
        {subscribers.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow className={darkMode ? "border-gray-700" : ""}>
                <TableHead className={darkMode ? "text-gray-400" : ""}>#</TableHead>
                <TableHead className={darkMode ? "text-gray-400" : ""}>Email</TableHead>
                <TableHead className={darkMode ? "text-gray-400" : ""}>Subscribed</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {subscribers.filter(s => !adminSearch || s.email?.toLowerCase().includes(adminSearch.toLowerCase())).map((sub, i) => (
                <TableRow key={sub.id} className={darkMode ? "border-gray-700/50 hover:bg-gray-700/30" : ""}>
                  <TableCell className={darkMode ? "text-gray-500" : "text-gray-500"}>{i + 1}</TableCell>
                  <TableCell className={`font-medium ${darkMode ? "text-gray-200" : ""}`}>{sub.email}</TableCell>
                  <TableCell className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-500"}`}>
                    {new Date(sub.subscribed_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="text-center py-12">
            <Mail className={`w-16 h-16 mx-auto mb-4 ${darkMode ? "text-gray-600" : "text-muted-foreground"}`} />
            <p className={darkMode ? "text-gray-400" : "text-muted-foreground"}>No subscribers yet</p>
            <p className={`text-sm mt-1 ${darkMode ? "text-gray-500" : "text-gray-400"}`}>Subscribers from the footer signup form will appear here</p>
          </div>
        )}
      </CardContent>
    </Card>
    </>
  );
};
